import type { LucideIcon } from 'lucide-react';
import { CreditCard, Drama, Gavel, RefreshCcw, ShieldAlert, Star } from 'lucide-react';

export const riskTypeMapper = {
  chargebacks: { title: 'Chargebacks', Icon: RefreshCcw },
  contentFindings: { title: 'Content Findings', Icon: CreditCard },
  reputational: { title: 'Reputational', Icon: Star },
  transactionLaundering: { title: 'Transaction Laundering', Icon: Drama },
  legal: { title: 'Legal Risk', Icon: Gavel },
  // Order matters: keys render in insertion order, so scamAndFraud sits below Legal Risk (BAL-8314).
  scamAndFraud: { title: 'Scam and Fraud', Icon: ShieldAlert },
} satisfies Record<
  | 'chargebacks'
  | 'contentFindings'
  | 'reputational'
  | 'transactionLaundering'
  | 'legal'
  | 'scamAndFraud',
  { title: string; Icon: LucideIcon }
>;
